import { useState } from 'react';
import { toast } from 'react-hot-toast';
import { useGenerateImage, useQueueStatus, useQueueResponse } from '@/data/ai-image';
import { trackEvent } from '@/data/utils/utils';

export const useImageGeneration = (product: any, refetchGeneratedImages: () => void) => {
  const [requestId, setRequestId] = useState<string | null>(null);
  const [status, setStatus] = useState<'pending' | 'success' | 'error' | null>(null);

  const { mutate: generateImage, isLoading: isGenerating } = useGenerateImage({
    onSuccess: (data) => {
      if (data.request_id) {
        setRequestId(data.request_id);
        setStatus('pending');
        refetchGeneratedImages();
        trackEvent('generate_image', product);
      } else {
        setStatus('error');
        toast.error(
          'Error generating image. Please try again later or contact support.'
        );
      }
    },
    onError: (error) => {
      toast.error(`Error generating image: ${error?.message}`);
      setStatus('error');
      setRequestId(null);
    },
  });

  useQueueStatus(requestId, {
    enabled: !!requestId && status === 'pending',
    refetchInterval: 1000,
    onSuccess: (data) => {
      if (data.status === 'success') {
        setStatus('success');
        refetchQueueResponse();
      }
    },
    onError: (error) => {
      toast.error(`Error generating image: ${error?.message}`);
      setStatus('error');
    },
  });

  const { refetch: refetchQueueResponse, isLoading: isLoadingResponse } =
    useQueueResponse(requestId, {
      enabled: false,
      onSuccess: () => {
        refetchGeneratedImages();
      },
      onError: (error) => {
        toast.error(`Error generating image: ${error?.message}`);
        setStatus('error');
        setRequestId(null);
      },
    });

  return {
    generateImage,
    isGenerating,
    status,
    isLoadingResponse
  };
}; 